import React from 'react';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import EditableDataTable from '../../_Shared/DataTables/EditableDataTable';

const _ = require('lodash');

class BudgetLineExternalMaps extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            budgetLine: this.props.budgetLine
        }
    }

    componentDidUpdate(prevProps) {
        const { budgetLine } = this.props;
        if (!_.isEqual(prevProps.budgetLine, budgetLine)) {
            this.setState({ budgetLine });
        }
    }

    provider = (index) => {
        const { providers } = this.props;
        const { budgetLine } = this.state;

        let aux = budgetLine.externalMaps[index];

        if (aux && aux.providerId) {
            let provider = providers.find(x => x.id === aux.providerId);
            if (provider) { return provider; }
        }

        return { externalFields: [] };
    }

    editExternalMap = (row, rowIndex) => {
        this.setState((prevState, state) => {
            let aux = Object.assign([], prevState.budgetLine.externalMaps);
            aux.splice(rowIndex, 1, row); 
            let budgetLine = Object.assign({}, prevState.budgetLine, { externalMaps: aux });
            this.props.onEditExternalMap(budgetLine);
            return { budgetLine }
        });
    }

    render() {
        const { providers, anchorEl, toggleRowMenu, selectExternalMap, action, addExternalMap, closeToggleRowMenu, deleteExternalMap } = this.props;
        const { budgetLine } = this.state;
        return (<Grid item xs>
                {
                    <EditableDataTable columns={[
                        {label: 'Provider', field: 'providerId', type: 'select', placeholder: 'Please select a Provider', options: providers},
                        {label: 'Flight Id', field: 'flightId', type: 'select-flight', placeholder: 'Please select a Flight', options: budgetLine.flights},
                        {label: 'External Field', field: 'externalField', type: 'select-external-field', placeholder: 'Please select an External Field'},
                        {label: 'External Id', field: 'externalId', type: 'string', fullWidth: true}]} 
                        anchorEl={anchorEl} rows={budgetLine.externalMaps} toggleRowMenu={toggleRowMenu} onElementSelect={selectExternalMap} 
                        action={action} onActionClick={addExternalMap} onEdit={this.editExternalMap} onCloseToggleRowMenu={closeToggleRowMenu} 
                        onFilterList={this.provider}>
                        <MenuItem onClick={deleteExternalMap}>
                            <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                            <ListItemText inset primary="Delete" />
                        </MenuItem>
                    </EditableDataTable>
                }
                </Grid>
        );
    }
}

export default BudgetLineExternalMaps;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/MediaPlan/BudgetLineExternalMaps.js